export default {"src":"/_next/static/media/dog-basic.432c7769.svg","height":49,"width":48};